import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/livro-talidomida`

    return {
        datatable(queryParms = {}) {

            return repository.get(`${baseUrl}/datatable?${urlUtil.serialize(queryParms)}`)
        },
        list() {

            return repository.get(`${baseUrl}/list`)
        },
        create() {

            return repository.get(`${baseUrl}/create`)
        },
        getLinhas(paginaId) {

            return repository.get(`${baseUrl}/linha/${paginaId}`)
        },
        store(params) {

            return repository.post(`${baseUrl}`, params)
        },
        edit(id) {

            return repository.get(`${baseUrl}/${id}/edit`)
        },
        update(id) {

            return repository.put(`${baseUrl}/${id}`)
        },
        fecharLivro(id) {

            return repository.put(`${baseUrl}/fechar/${id}`)
        },
        getDataAbertura(livroRegistroId, livroRegistroTipoId) {

            return repository.get(`${baseUrl}/data-abertura/${livroRegistroId}/${livroRegistroTipoId}`)
        },
    }
}